import { useRef, useState } from "react";

export interface UseClipboardOptions {
  timeout?: number;
}

export function useClipboard(opts?: UseClipboardOptions) {
  const [copyButton, setCopyButton] = useState({ isCopied: false });
  const timeoutRef = useRef<number | null>(null);

  async function copy(value: string) {
    await navigator.clipboard.writeText(value);

    setCopyButton({ isCopied: true });

    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = window.setTimeout(() => {
      timeoutRef.current = null;
      setCopyButton({ isCopied: false });
    }, opts?.timeout || 3000);
  }

  return {
    state: copyButton,
    copy,
  };
}
